import { createFileRoute } from "@tanstack/react-router";
import { Target } from "lucide-react";

import { ContentOutputChart } from "@/components/brand-intel/competitive/content-output-chart";
import { ShareOfVoiceChart } from "@/components/brand-intel/competitive/share-of-voice-chart";
import { PageHeader } from "@/components/layout/heading";

export const Route = createFileRoute("/dashboard/intelligence/_layout/competitive")({
  component: Competitive,
});

export function Competitive() {
  return (
    <section className="w-full space-y-6">
      <PageHeader title={
        <div className="flex items-center gap-2">
          <Target className="size-5 text-muted-foreground" strokeWidth={2.5} />
          Competitive Intelligence
        </div>
      } />
   
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-[2fr_1fr]">
        <ContentOutputChart />
        <ShareOfVoiceChart />
      </div>
    </section>
  );
}
